import type { RootState } from "@src/store/rootState";
import { isSelectedVariationControl } from "@src/store/slices/experienceBuilder/common/selectors/isSelectedVariationControl";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { selectedExperience } from "@src/store/slices/experiences";

export function getModificationsLockStatus(state: RootState) {
  const experience = selectedExperience(state);
  if (experience.category === "personalization") {
    return "disabled";
  }
  const isControl = isSelectedVariationControl(state);
  if (!isControl) {
    return "disabled";
  }

  const locked = experienceBuilderSlice.selectors.getControlGroupLocked(state);
  return locked ? "locked" : "unlocked";
}
